import classNames from 'classnames/bind';
import styles from './TestimonialSession.module.scss';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faStar} from "@fortawesome/free-solid-svg-icons";
import {useAssetsImage} from '~/pages/context/AssetsImageContext';
import {useEffect, useRef} from "react";
import {ImageSkeleton} from '~/components';
const cx = classNames.bind(styles);

function TestimonialSession(){
    const {getImageUrlById} = useAssetsImage();
    const carouselRef = useRef(null);
    useEffect(() => {
        if(carouselRef.current){
            const carousel = new window.bootstrap.Carousel(carouselRef.current, {
                interval: 5000,
                wrap: true
            })
        }
    }, [])
    return (
        <div className="position-relative">
            <div className={cx('bg-13','bg-holder z-2 d-none d-md-block')}></div>
            <div className={cx('bg-12', 'bg-holder z-2 d-none d-md-block d-lg-none d-xl-block')}></div>
            <div className="bottom-0 start-0 end-0 bg-body-emphasis">
                <svg className="w-100" viewBox="0 0 1920 368" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path className="fill-body-bg" d="M1920 0.44L0 367.74V0H1920V0.44Z"></path>
                </svg>
            </div>
            <section className="pb-0 bg-body-emphasis overflow-hidden position-static">
                <div className="container-medium">
                    <div className="row">
                        <div className="col-lg-6 mb-6 text-center text-lg-start z-2">
                            <h4 className="text-primary fw-bolder mb-3">Testimonial</h4>
                            <h2 className="mb-3 text-body-emphasis">More than 2 Millions happy<br/>Customers and
                                counting</h2>
                            <p className="mb-5">You may now concentrate on the functionality and other <br
                                className="d-none d-sm-block"/>aspects of your web products thanks to Phoenix's strength<br
                                className="d-none d-sm-block"/>before leaving the UI design to us. It is simple to
                                complete<br className="d-none d-sm-block"/>the work after checking and double-checking.
                            </p>
                        </div>
                        <div className="col-lg-6 z-2">
                            <div className="carousel slide" ref={carouselRef} id="carouselExampleIndicators" data-bs-ride="carousel">
                                <div className="carousel-inner">
                                    <div className="carousel-item active">
                                        <div className="row g-1 g-lg-0 g-xl-1 pb-lg-3 pb-xl-0 ps-lg-1 ps-xl-0">
                                            <div className="col-lg-6 col-xl-5 text-center">
                                                <div className="testimonial-avatar-container d-inline-block position-relative">
                                                    <div className={cx('bg-2','bg-holder')}></div>
                                                    <ImageSkeleton className={"rounded-3 mb-lg-0 opacity-100 position-relative"} id={51} heightLoading={100}  width="153" height="153"/>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-xl-7 text-center text-lg-start">
                                                <div className="mb-4">
                                                    {
                                                        Array.from({ length: 5 }, (_, index) => (
                                                            <FontAwesomeIcon icon={faStar} key={index} className='text-primary'/>
                                                        ))
                                                    }
                                                </div>
                                                <h3 className="fs-7 fs-xl-6 mb-5 lh-sm me-md-7 me-lg-0">Brilliant app!
                                                    Will definitely going to be my first choice starting from today</h3>
                                                <h6>Monica Gomez</h6>
                                                <h6 className="fw-normal">UX designer, Google</h6>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="carousel-item">
                                        <div className="row g-1 g-lg-0 g-xl-1 pb-lg-3 pb-xl-0 ps-lg-1 ps-xl-0">
                                            <div className="col-lg-6 col-xl-5 text-center">
                                                <div
                                                    className="testimonial-avatar-container d-inline-block position-relative">
                                                    <ImageSkeleton className={"rounded-3 mb-lg-0 opacity-100 position-relative"} id={52} heightLoading={100}  width="153" height="153"/>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-xl-7 text-center text-lg-start">
                                                <div className="mb-4" data-bs-theme="light">
                                                    {
                                                        Array.from({ length: 5 }, (_, index) => (
                                                            <FontAwesomeIcon icon={faStar} key={index} className='text-primary'/>
                                                        ))
                                                    }
                                                </div>
                                                <h3 className="fs-7 fs-xl-6 mb-5 lh-sm me-md-7 me-lg-0">“Excellent to
                                                    work with and comfortable to customize. This is what I was looking
                                                    for till the date!”</h3>
                                                <h6>Marc Chiasson</h6>
                                                <h6 className="fw-normal">UX designer, Adobe</h6>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="carousel-item">
                                        <div className="row g-1 g-lg-0 g-xl-1 pb-lg-3 pb-xl-0 ps-lg-1 ps-xl-0">
                                            <div className="col-lg-6 col-xl-5 text-center">
                                                <div
                                                    className="testimonial-avatar-container d-inline-block position-relative">
                                                    <div className={cx('bg-2','bg-holder')}></div>
                                                    <ImageSkeleton className={"rounded-3 mb-lg-0 opacity-100 position-relative"} id={53} heightLoading={100}  width="153" height="153"/>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-xl-7 text-center text-lg-start">
                                                <div className="mb-4" data-bs-theme="light">
                                                    {
                                                        Array.from({ length: 5 }, (_, index) => (
                                                            <FontAwesomeIcon icon={faStar} key={index} className='text-primary'/>
                                                        ))
                                                    }
                                                </div>
                                                <h3 className="fs-7 fs-xl-6 mb-5 lh-sm me-md-7 me-lg-0">“BreakThrough is all
                                                    you can ask for. This is perfect fit for everything you might want
                                                    to work on!”</h3>
                                                <h6>Axel Barry</h6>
                                                <h6 className="fw-normal">UX designer, Apple</h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default TestimonialSession;